export function validateExpectedStartStatus(
  start: number,
  end: number,
): string {
  if (start == 200 && end == 200) {
    return "";
  }
  if (!start && end) {
    return "Both start and end statuses must be filled in.";
  }

  if (start > end) {
    return "Start must be smaller than end.";
  }

  if (start < 100 || start > 600) {
    return "Statuses must between 100 and 600.";
  }

  return "";
}

export function validateExpectedEndStatus(start: number, end: number): string {
  if (start == 200 && end == 200) {
    return "";
  }
  if (start && !end) {
    return "Both start and end statuses must be filled in.";
  }

  if (end < start) {
    return "End must be larger than start.";
  }

  if (end < 100 || end > 600) {
    return "Statuses must between 100 and 600.";
  }

  return "";
}
